module.exports = __webpack_public_path__ + "img/icon_submenu20dark.a0c03259.svg";